<template>
  <div>
    <pb-divider
      v-for="(item, index) in bannerOptions"
      :key="index"
      :distance="2.4"
    >
      <div class="before-banner" v-if="!sortItems[item.value]">
        <pb-button
          class="empty-title"
          size="small"
          width="180"
          @click="showModalHandler('write', item.value)"
        >
          <i :class="bannerIcon[index]" /> {{ item.label }} 등록하기
        </pb-button>
      </div>

      <div v-else>
        <div class="campaign-manage-card">
          <div class="campaign-manage-card__content">
            <pb-divider :distance="1.6">
              <h2>
                <span>
                  {{ typeString(sortItems[item.value].type) }}
                </span>

                <diV
                  class="tools"
                  v-if="sortItems[item.value].push_status !== '1'"
                >
                  <a
                    class="link-btn"
                    @click="() => modifyModalHandler(sortItems[item.value])"
                  >
                    <i class="fas fa-pen-alt"></i> 수정
                  </a>
                  <a
                    class="link-btn"
                    @click="() => deleteHandler(sortItems[item.value])"
                  >
                    <i class="far fa-trash-alt"></i> 삭제
                  </a>
                </diV>
                <div class="tools disabled-text" v-else>
                  푸시알림 성공시 수정, 삭제 불가능합니다.
                </div>
              </h2>
            </pb-divider>

            <pb-divider :distance="2.4">
              <div class="campaign-manage-card__image">
                <img
                  :src="sortItems[item.value].image"
                  :alt="typeString(sortItems[item.value].type)"
                  :title="typeString(sortItems[item.value].type) + ' 이미지'"
                  :id="`image${sortItems[item.value].idx}`"
                />
                <div class="image-size">
                  가로
                  {{ imgSize[index] ? imgSize[index].width : "" }}
                  * 세로
                  {{ imgSize[index] ? imgSize[index].height : "" }}
                  (단위: px)
                </div>
              </div>
            </pb-divider>

            <div class="link">
              <div
                class="campaign-manage-card__title"
                v-if="sortItems[item.value].title"
              >
                제목 :: {{ sortItems[item.value].title }}
              </div>
              <div
                class="campaign-manage-card__subtitle"
                v-if="sortItems[item.value].subtitle"
              >
                부제목 :: {{ sortItems[item.value].subtitle }}
              </div>

              <div
                class="campaign-manage-card__subtitle"
                v-if="typeString(sortItems[item.value].type) === '푸시알림'"
              >
                <span v-if="sortItems[item.value].push_status === '0'">
                  예약상태 입니다.
                </span>
                <span
                  class="text-success"
                  v-else-if="sortItems[item.value].push_status === '1'"
                >
                  푸시 알림이 성공적으로 발송되었습니다.
                </span>
                <span class="text-error" v-else>
                  푸시 알림 발송을 실패하셨습니다.
                </span>
                <span>
                  (
                  <i class="far fa-clock"></i>
                  {{ sortItems[item.value].push_datetime | dateFormat }}
                  )
                </span>
              </div>

              <pb-divider :distance="2">
                <input
                  type="text"
                  :value="sortItems[item.value].url"
                  :id="`ad_${index}`"
                  class="link-input"
                  readonly
                />
              </pb-divider>

              <pb-divider>
                <a
                  class="link-btn"
                  :href="sortItems[item.value].url"
                  title="링크이동"
                  target="_blank"
                >
                  <i class="fas fa-share"></i> 링크이동
                </a>
                <a class="link-btn" @click="() => copyHandler(`ad_${index}`)">
                  <i class="far fa-copy"></i> 링크복사
                </a>
              </pb-divider>
            </div>
          </div>
        </div>
      </div>
    </pb-divider>

    <pb-modal
      v-model="modalToggle"
      width="550"
      :beforeClose="beforeClose"
      @confirm="fetchNavigation"
    >
      <template slot="header">
        캠페인 편집 {{ typeString(item.type) }}
      </template>

      <pb-divider>
        <pb-selector
          v-model="write.type"
          size="small"
          :options="bannerNotIncludeAleadyItem"
          subTitle="유형"
          :disabled="mode === 'modify'"
          placeholder="유형을 선택해주세요."
        />
      </pb-divider>

      <pb-divider v-if="chooseType === '2' || chooseType === '3'">
        <pb-input
          v-model="write.title"
          size="small"
          subTitle="제목"
          placeholder="제목을 작성해주세요."
        />
      </pb-divider>

      <pb-divider v-if="chooseType === '2' || chooseType === '3'">
        <pb-input
          v-model="write.subtitle"
          size="small"
          subTitle="부제목"
          placeholder="부제목을 작성해주세요."
        />
      </pb-divider>

      <pb-divider v-if="chooseType === '3'">
        <pb-input size="small" subTitle="푸시알림 시간">
          <template slot="instead">
            <datetime
              v-model="write.push_datetime"
              type="datetime"
              input-id="push_datetime"
              class="theme-black"
              value-zone="Asia/Seoul"
              zone="Asia/Seoul"
              :auto="true"
              :min-datetime="limitDate.start"
              :max-datetime="limitDate.end"
              :phrases="{ ok: '적용', cancel: '닫기' }"
              placeholder="알림 시간을 설정해주세요."
            />
          </template>
        </pb-input>
      </pb-divider>

      <pb-divider>
        <pb-input
          v-model="write.url"
          size="small"
          subTitle="URL"
          placeholder="URL을 작성해주세요."
        />
      </pb-divider>

      <pb-divider>
        <pb-upload
          :value="uploadFileResult"
          id="bannerUpload"
          size="small"
          formdata
          subTitle="이미지"
          placeholder="이미지를 선택해주세요."
          @upload="uploadHandler"
        />
      </pb-divider>
    </pb-modal>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { format } from "@/components/utils.js";
import {
  BANNER_TYPE,
  BANNER_ICON,
  BANNER_TYPE_OPTION,
} from "@/lib/staticValue.js";
import { isEmpty, hasOwnProperty } from "@/lib/utils.js";
import { base } from "@/api";
import dayjs from "dayjs";

// import AddCampaignItem from "@/components/AddCampaignItem.vue";
// import EmptyState from "@/components/EmptyState.vue";
// import DeleteConfirm from "@/components/DeleteConfirm.vue";
// import EmptyItem from "@/common/EmptyItem";

export default {
  name: "CampaignItemList",
  data: () => ({
    modalToggle: false,
    loading: false,
    imgSize: [],
    bannerOptions: BANNER_TYPE_OPTION,
    bannerIcon: BANNER_ICON,
    uploadFileResult: null,
    mode: "write",

    // write
    write: {
      title: null,
      subtitle: null,
      type: null,
      url: null,
      push_datetime: null,
    },
    tempStore: {
      title: null,
      subtitle: null,
      type: null,
      url: null,
      push_datetime: null,
    },
  }),
  props: {
    idx: Number,
  },
  computed: {
    ...mapState({
      campaign: "campaign",
      items: "items",
      item: "item",
    }),

    limitDate() {
      if (this.campaign.start_date === this.campaign.end_date) {
        return {
          start: new Date(`${this.campaign.start_date} 00:00:00`).toISOString(),
          end: new Date(`${this.campaign.start_date} 23:00:00`).toISOString(),
        };
      }

      return {
        start: new Date(this.campaign.start_date).toISOString(),
        end: new Date(this.campaign.end_date).toISOString(),
      };
    },

    sortItems() {
      if (this.items.length !== 0) {
        let sort = [];

        for (let i = 0; i < 4; i++) {
          const item = this.items.filter(({ type }) => type === i);
          if (item.length > 0) {
            sort[i] = item[0];
          } else {
            sort[i] = null;
          }
        }

        return sort;
      }

      return [];
    },

    bannerNotIncludeAleadyItem() {
      if (
        this.items.length === 0 ||
        (hasOwnProperty(this.items[0], "idx") && this.items[0].idx === null)
      ) {
        return BANNER_TYPE_OPTION;
      }

      const alreadyItem = this.items.map(({ type }) => type.toString());
      const notIncludeType = BANNER_TYPE_OPTION.filter(
        ({ value }) => !alreadyItem.includes(value)
      );

      return this.mode === "write" ? notIncludeType : BANNER_TYPE_OPTION;
    },

    // type 선택에 따른 form 변경
    chooseType() {
      if (!isEmpty(this.write.type)) {
        return this.write.type;
      }

      return null;
    },

    typeString() {
      return (type) => {
        const banner_type = BANNER_TYPE[type];
        return isEmpty(banner_type) ? "" : banner_type;
      };
    },
  },
  filters: {
    dateFormat(date) {
      return dayjs(date)
        .subtract(9, "hours")
        .format("YYYY.MM.DD HH:mm:ss");
    },
  },
  methods: {
    ...mapMutations(["SET_ITEM"]),
    ...mapActions(["FETCH_CAMPAIGN", "DELETE_ITEM", "ADD_ITEM", "UPDATE_ITEM"]),

    hasOwnProps(item) {
      return (
        !isEmpty(item) && hasOwnProperty(item, "idx") && !isEmpty(item.idx)
      );
    },

    _hasOwnProperty(item) {
      if (isEmpty(item)) {
        return false;
      } else {
        return hasOwnProperty(item, "type") ? item.type.toString() : false;
      }
    },

    fetchData() {
      this.loading = true;
      return this.FETCH_CAMPAIGN({
        idx: this.$route.params.id,
      }).then(() => {
        this.loading = false;
      });
    },

    deleteData(item) {
      return this.DELETE_ITEM({
        idx: item.idx,
      });
    },

    fetchReady() {
      let { title, subtitle, type, url, push_datetime } = this.write;
      const image = this.uploadFileResult;
      const needTitle = type === "2" || type === "3";
      let data = {};

      if (isEmpty(type)) {
        this.$alert.error("유형을 선택해주세요.");
        return;
      }

      if (needTitle && isEmpty(title)) {
        this.$alert.error("제목을 작성해주세요.");
        return;
      }

      if (needTitle && isEmpty(subtitle)) {
        this.$alert.error("부제목을 작성해주세요.");
        return;
      }

      if (type.toString() === "3" && isEmpty(push_datetime)) {
        this.$alert.error("푸시알림 시간을 작성해주세요.");
        return;
      }

      if (isEmpty(url)) {
        this.$alert.error("링크 url을 작성해주세요.");
        return;
      }

      if (isEmpty(image)) {
        this.$alert.error("이미지를 선택해주세요.");
        return;
      }

      if (needTitle) {
        if (type === "3" && !/^(\(광고\))/.test(title)) {
          title = `(광고)${title}`;
        }

        data = { ...data, title, subtitle };
      }

      if (type === "3") {
        data = {
          ...data,
          push_datetime: format("yyyy-MM-DD H:i:00", push_datetime),
        };
      }

      return {
        ...data,
        image,
        url,
        type,
        campaign: this.item.campaign,
      };
    },

    fetchNavigation() {
      if (this.mode === "write") {
        this.confirmHandler();
      }

      if (this.mode === "modify") {
        this.modifyHandler();
      }
    },

    async confirmHandler() {
      const data = this.fetchReady();

      if (isEmpty(data)) return;

      try {
        await this.ADD_ITEM({ payload: data });
        this.$alert.info("배너가 등록되었습니다.");
        this.showModalHandler();
        this.insertClear();
      } catch (err) {
        this.$alert.error(err.message);
      }
    },

    modifyHandler() {
      const data = this.fetchReady();

      if (isEmpty(data)) return;

      if (data.type === "3" && this.write.push_status === "1") {
        this.$confirm.show({
          title: "경고",
          content:
            "푸시알림이 중복발송 될 수도 있습니다.<br/>그래도 수정하시겠습니까?",
          onConfirm: () => {
            try {
              this.UPDATE_ITEM({
                idx: this.write.idx,
                payload: data,
              });
              this.$alert.info("업데이트를 성공적으로 마쳤습니다.");
              this.showModalHandler();
              this.insertClear();
            } catch (e) {
              this.$alert.error(e.message);
            }
          },
        });
      } else {
        try {
          this.UPDATE_ITEM({
            idx: this.write.idx,
            payload: data,
          });
          this.$alert.info("업데이트를 성공적으로 마쳤습니다.");
          this.showModalHandler();
          this.insertClear();
        } catch (e) {
          this.$alert.error(e.message);
        }
      }
    },

    deleteHandler(item) {
      this.$confirm.show({
        title: "배너 삭제",
        content: "해당 배너를 삭제하시겠습니까?",
        onConfirm: () => {
          this.DELETE_ITEM({ idx: item.idx });
          this.$alert.info("삭제가 완료되었습니다.");
        },
      });
    },

    insertClear() {
      this.uploadFileResult = null;
      this.write = {
        title: null,
        subtitle: null,
        type: null,
        url: null,
        push_datetime: null,
      };
    },

    modifyModalHandler(item) {
      if (!isEmpty(item)) {
        // timezone 이 안맞아서 수정함
        const date = new Date(item.push_datetime).getTime();
        const hour = 9 * 60 * 60 * 1000;
        const transform = date - hour;
        const push = new Date(transform);

        this.write = {
          ...item,
          type: item.type.toString(),
          push_datetime: format("yyyy-MM-DDTH:i:s.000+09:00", push),
        };

        this.tempStore = {
          ...item,
          type: item.type.toString(),
          push_datetime: format("yyyy-MM-DDTH:i:s.000+09:00", push),
        };

        this.uploadFileResult = item.image;
      }

      this.showModalHandler("modify");
    },

    showModalHandler(mode, type) {
      if (type) {
        this.write.type = type;
      }

      this.modalToggle = !this.modalToggle;
      this.mode = mode || "write";
    },

    beforeClose() {
      if (!this.modalToggle) {
        this.insertClear();
      }
    },

    async uploadHandler(file) {
      const response = await base.upload(file);

      if (response.status === 200) {
        this.uploadFileResult = response.data;
      } else {
        this.$alert.error("업로드시 문제가 발생되었습니다.");
      }
    },

    copyHandler(inputId) {
      const input = document.querySelector(`#${inputId}`);
      input.select();
      document.execCommand("copy");
      input.blur();
      alert("링크가 복사되었습니다.");
    },

    cleanCampaignItem() {
      this.SET_ITEM({
        campaign: this.$route.params.id,
        title: null,
        subtitle: null,
        type: null,
        url: null,
        push_datetime: null,
        image: null,
      });
    },
  },
  watch: {
    items(nVal) {
      setTimeout(() => {
        for (var i = 0; i < 4; i++) {
          const item = nVal.filter(({ type }) => type === i)[0];

          if (!isEmpty(item) && hasOwnProperty(item, "type")) {
            let el = document.querySelector(`#image${item.idx}`);
            this.imgSize.push({
              width: el.naturalWidth,
              height: el.naturalHeight,
            });
          } else {
            this.imgSize.push(null);
          }
        }
      }, 150);
    },
  },
  components: {},
  mounted() {},
  created() {
    this.cleanCampaignItem();
    this.fetchData();
  },
};
</script>

<style lang="scss">
@import "~styles/size";

.before-banner {
  width: calc(450px + 48px);
  margin: 0 auto;
  height: 300px;
  line-height: 300px;
  text-align: center;
  background-color: #f4f4f4;

  .empty-title {
    i {
      margin-right: 6px;
    }
  }
}

.campaign-manage-banner-tool {
  font-size: 1.4rem;
  width: calc(450px + 48px);
  margin: 0 auto;

  a:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  a + a {
    margin-left: 12px;
  }
}

.campaign-manage-card {
  padding: 32px 24px;
  border-radius: 5px;

  &__content {
    width: calc(450px + 48px);
    margin: 0 auto;

    @media (max-width: $min_layout) {
      width: 100%;
    }
  }

  &__title {
    font-size: 1.6rem;
  }

  &__subtitle {
    font-size: 1.4rem;
  }

  a {
    color: #242424;
    text-decoration: none;
    vertical-align: bottom;
    font-size: 1.4rem;
    cursor: pointer;

    &.link-btn + .link-btn {
      margin-left: 12px;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  h2 {
    font-size: 2rem;
    padding-bottom: 0.5rem;
    display: flex;
    height: 32px;
    justify-content: space-between;
    align-items: center;

    .tools {
      font-size: 14px;
      font-weight: normal;

      &.disabled-text {
        color: #a2a2a2;
      }
    }
  }

  .link {
    font-size: 1.4rem;

    & > div {
      margin-top: 1rem;
    }

    .link-input {
      font-size: 1.4rem;
      width: 100%;
      outline: none;
      padding: 0.9rem 1.2rem;
      border-radius: 5px;
      border: none;
      background-color: #ffffff;
      color: #242424;
    }
  }

  &__image {
    text-align: center;
  }

  img {
    display: block;
    width: 100%;
  }

  .image-size {
    margin-top: 1rem;
    font-size: 1.2rem;
  }
}
</style>
